import * as prettier from "prettier/standalone";
import * as prettierPluginBabel from "prettier/plugins/babel";
import * as prettierPluginHtml from "prettier/plugins/html";
import * as prettierPluginYaml from "prettier/plugins/yaml";
import * as prettierPluginEstree from "prettier/plugins/estree";
import * as prettierPluginCss from "prettier/plugins/postcss";
import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-json";
import "prismjs/components/prism-css";
static const languages = {
  js: Prism.languages.javascript,
  html: Prism.languages.html,
  json: Prism.languages.json,
  css: Prism.languages.css,
};
static const languageMap = {
  js: "javascript",
  html: "html",
  json: "json",
  css: "",
};
export interface Input {
  type: "js" | "css" | "html" | "json";
  height?: number;
  code?: string;
  bodyCode?: string;
  content?: Marko.Body;
}

<const/parser=(input.type === "js" ? "babel" : input.type || "html")>
<const/code=input.code || input.bodyCode || "">
<const/promise=prettier.format(code.trim(), {
  parser,
  plugins: [
    prettierPluginBabel,
    prettierPluginHtml,
    prettierPluginYaml,
    prettierPluginEstree as any,
    prettierPluginCss,
  ],
})>

<await|output|=promise>
  <try>
    <@catch|error|>
      <log=error>
      <pre><code class="language-plaintext">$!{error}</code></pre>
    </@catch>

    <const/html=Prism.highlight(
      output,
      languages[input.type],
      languageMap[input.type],
    )>
    <pre tabindex=0 class=`language-${input.type || "html"}`><code class=`language-${input.type || "html"}`>$!{html}</code></pre>
  </try>
</await>

<style>
  pre[class*="language-"] {
    max-height: 400px;
    overflow: auto;
  }

  pre[class*="language-"]::-webkit-scrollbar {
    background-color: var(--color-code-scrollbar);
    border-radius: 12px;
  }

  pre[class*="language-"]::-webkit-scrollbar:vertical {
    width: 6px;
  }

  pre[class*="language-"]::-webkit-scrollbar:horizontal {
    height: 6px;
  }

  pre[class*="language-"]::-webkit-scrollbar-thumb {
    background-color: var(--color-code-scrollbar-thumb);
    border-color: transparent;
    border-radius: 12px;
    border-right-style: inset;
    box-shadow: none;
  }
</style>
